import React from 'react';
import FormModal from '../../../common/form/FormModal';
import CreativeCreditsFormItems from './CreativeCreditsFormItems';

export default function CreativeCreditsModal({
    isOpen,
    onClose,
    onSave,
    isSaving,
    title,
    disableTypeField,
    showReferenceId,
    saveLabel,
    modalBodyAccessory
}) {
    return (
        <FormModal
            id={'add-person-creative-credits-form-modal'}
            title={title}
            isOpen={isOpen}
            onClose={onClose}
            onSave={onSave}
            isSaving={isSaving}
            saveLabel={saveLabel}
            sx={{ height: { xs: '100%', sm: 'auto' } }}
        >
            <CreativeCreditsFormItems
                disableTypeField={disableTypeField}
                showReferenceId={showReferenceId}
                footerAccessory={modalBodyAccessory}
            />
        </FormModal>
    );
}
